const ACCOUNT_DETAILS_FIELDS = [
  {
    name: 'email',
    label: 'Email Address',
    fieldName: 'email',
    editFieldName: 'emailAddress',
    isEditable: true,
  },
  {
    name: 'firstName',
    label: 'First Name',
    fieldName: 'firstName',
    editFieldName: 'firstName',
    isEditable: false,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    fieldName: 'lastName',
    editFieldName: 'lastName',
    isEditable: false,
  },
  {
    name: 'dateOfBirth',
    label: 'Date of Birth',
    fieldName: 'computedDateOfBirth',
    editFieldName: 'birthDate',
    isEditable: false,
  },
  {
    name: 'phone-number',
    label: 'Contact Number',
    fieldName: 'contactNumber',
    editFieldName: 'contactNumber',
    isEditable: true,
  },
  {
    name: 'jobTitle',
    label: 'Occupation',
    fieldName: 'jobLocalisedName',
    editFieldName: 'jobTitle',
    isEditable: false,
  },
  {
    name: 'salaryRange',
    label: 'Monthly Net Income',
    fieldName: 'computedSalaryRange',
    editFieldName: 'salaryRange',
    isEditable: false,
  },
];

export default ACCOUNT_DETAILS_FIELDS;
